import { render, staticRenderFns } from "./HospitalSurgeriesPopup.vue?vue&type=template&id=376dfcc1"
import script from "./HospitalSurgeriesPopup.vue?vue&type=script&lang=js"
export * from "./HospitalSurgeriesPopup.vue?vue&type=script&lang=js"
import style0 from "./HospitalSurgeriesPopup.vue?vue&type=style&index=0&id=376dfcc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports